module.exports = __webpack_public_path__ + "static/media/Cancellations.13aa895f.svg";